export var RealisationsActionTypes;
(function (RealisationsActionTypes) {
    RealisationsActionTypes["FETCH_REALISATIONS_ATTEMPT"] = "FETCH_REALISATIONS_ATTEMPT";
    RealisationsActionTypes["FETCH_REALISATIONS_SUCCESS"] = "FETCH_REALISATIONS_SUCCESS";
    RealisationsActionTypes["FETCH_REALISATIONS_FAILURE"] = "FETCH_REALISATIONS_FAILURE";
})(RealisationsActionTypes || (RealisationsActionTypes = {}));
